var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/findjobs"}},[_c('button',{staticClass:"btn text-uppercase",class:_vm.classes,domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }